/**
 * @module: 空数据组件
 * @author: Liang Huang
 * @date: 2019-10-08 09:57:51
 */
import React from 'react';
import PropTypes from 'prop-types';
import './style';

var Empty = function Empty(props) {
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: "empty-container ".concat(props.className ? props.className : ''),
      style: props.style
    },
    /*#__PURE__*/
    React.createElement("div", {
      className: "content"
    }, !props.onlyTxt &&
    /*#__PURE__*/
    React.createElement("img", {
      src: require('./imgs/icon-empty.png'),
      alt: ""
    }), props.tips ?
    /*#__PURE__*/
    React.createElement("p", {
      className: "tips"
    }, props.tips) : null,
    /*#__PURE__*/
    React.createElement("p", null, props.txt || '暂无数据!')), props.children)
  );
};

Empty.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  tips: PropTypes.string,
  txt: PropTypes.string,
  children: PropTypes.node,
  onlyTxt: PropTypes.bool
};
export default Empty;